import { defineMessages } from 'react-intl';

/** The copy of the lyric line panel (design `studio-details` frame b). */
export const lyricPanelMessages = defineMessages({
  title: { id: 'app.sml.promote.studio.lyricPanel.title', defaultMessage: 'Pick the line' },
  lineCount: {
    id: 'app.sml.promote.studio.lyricPanel.lineCount',
    defaultMessage: '{count, plural, one {# line} other {# lines}}',
  },
  modes: { id: 'app.sml.promote.studio.lyricPanel.modes', defaultMessage: 'Lines' },
  oneLine: { id: 'app.sml.promote.studio.lyricPanel.oneLine', defaultMessage: '1 line' },
  twoLines: { id: 'app.sml.promote.studio.lyricPanel.twoLines', defaultMessage: '2 lines' },
  searchLabel: { id: 'app.sml.promote.studio.lyricPanel.searchLabel', defaultMessage: 'Find a word in the lyrics' },
  searchCount: {
    id: 'app.sml.promote.studio.lyricPanel.searchCount',
    defaultMessage: '{count, plural, one {# line} other {# lines}}',
  },
  clear: { id: 'app.sml.promote.studio.lyricPanel.clear', defaultMessage: 'Clear' },
  searchHits: {
    id: 'app.sml.promote.studio.lyricPanel.searchHits',
    defaultMessage: '{count, plural, one {# line has} other {# lines have}} "{query}"',
  },
  suggested: { id: 'app.sml.promote.studio.lyricPanel.suggested', defaultMessage: 'Suggested' },
  part: { id: 'app.sml.promote.studio.lyricPanel.part', defaultMessage: 'Part {number}' },
  repeat: { id: 'app.sml.promote.studio.lyricPanel.repeat', defaultMessage: '×{count}' },
  hook: { id: 'app.sml.promote.studio.lyricPanel.hook', defaultMessage: 'Hook' },
  short: { id: 'app.sml.promote.studio.lyricPanel.short', defaultMessage: 'Short' },
  inPreview: { id: 'app.sml.promote.studio.lyricPanel.inPreview', defaultMessage: 'In the preview' },
  noLyricsTitle: {
    id: 'app.sml.promote.studio.lyricPanel.noLyricsTitle',
    defaultMessage: 'This song has no lyrics yet',
  },
  noLyricsText: {
    id: 'app.sml.promote.studio.lyricPanel.noLyricsText',
    defaultMessage: 'The Studio reads the lyrics from the catalog. Add them on the song page, then come back here.',
  },
  addLyrics: { id: 'app.sml.promote.studio.lyricPanel.addLyrics', defaultMessage: 'Add lyrics in Catalog' },
  noHitTitle: { id: 'app.sml.promote.studio.lyricPanel.noHitTitle', defaultMessage: 'No line has "{query}"' },
  noHitText: {
    id: 'app.sml.promote.studio.lyricPanel.noHitText',
    defaultMessage: 'Try one word, or clear the search to see every line.',
  },
  clearSearch: { id: 'app.sml.promote.studio.lyricPanel.clearSearch', defaultMessage: 'Clear the search' },
  characters: {
    id: 'app.sml.promote.studio.lyricPanel.characters',
    defaultMessage: '{count, plural, one {# character} other {# characters}}',
  },
  fullLimit: {
    id: 'app.sml.promote.studio.lyricPanel.fullLimit',
    defaultMessage: 'Fits {count} at full size',
  },
  fitFull: { id: 'app.sml.promote.studio.lyricPanel.fitFull', defaultMessage: 'Fits at full size.' },
  fitShrinks: {
    id: 'app.sml.promote.studio.lyricPanel.fitShrinks',
    defaultMessage: 'The type gets smaller to fit (down to 70 %). It still reads well.',
  },
  fitTooLongOne: {
    id: 'app.sml.promote.studio.lyricPanel.fitTooLongOne',
    defaultMessage: 'Too long for the big type. Pick a shorter line.',
  },
  fitTooLongTwo: {
    id: 'app.sml.promote.studio.lyricPanel.fitTooLongTwo',
    defaultMessage: 'Too long for the big type. Pick one line, or a shorter pair.',
  },
  noPick: { id: 'app.sml.promote.studio.lyricPanel.noPick', defaultMessage: 'Pick a line' },
  change: { id: 'app.sml.promote.studio.lyricPanel.change', defaultMessage: 'Change' },
  useLine: { id: 'app.sml.promote.studio.lyricPanel.useLine', defaultMessage: 'Use this line' },
  fitsShort: { id: 'app.sml.promote.studio.lyricPanel.fitsShort', defaultMessage: 'fits' },
  shrinksShort: { id: 'app.sml.promote.studio.lyricPanel.shrinksShort', defaultMessage: 'gets smaller' },
  tooLongShort: { id: 'app.sml.promote.studio.lyricPanel.tooLongShort', defaultMessage: 'too long' },
});
